import { graphql, fetchQuery } from 'react-relay';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { getItemIdFromUri } from '../../../utils/getItemIdFormUri';
import { PRIORITIES, SHOW_PDP_SOURCING } from '../pdpSharedNotificationConstants';

const query = graphql`
    query pdpSharedNotificationPdpSourcingModalConfigQuery(
        $itemIds: [String]!
        $userId: String = ""
    ) {
        viewer {
            soldHoldPdpSourcingModal: featureFlag(feature: "soldHoldPdpSourcingModal")
            item: itemRead(itemIds: $itemIds) {
                ... on Item {
                    displayInfo(page: pdp, buyerId: $userId) {
                        ctas {
                            showRequestSourcing
                        }
                    }
                }
            }
        }
    }
`;

const pdpSourcingRule = async ({ relayEnvironment }) => {
    const itemId = getItemIdFromUri(location.pathname);
    const userId = getBuyerId(document.cookie);
    const isTradeUser = getUserType(document.cookie) === 'trade';

    if (!itemId || !userId || !isTradeUser) {
        return Promise.resolve(false);
    }

    const response = await fetchQuery(relayEnvironment, query, { itemIds: [itemId], userId });
    const viewer = response?.viewer;

    const showRequestSourcing = viewer?.item?.[0]?.displayInfo?.ctas?.showRequestSourcing;
    const soldHoldPdpSourcingModal = viewer?.soldHoldPdpSourcingModal;

    return showRequestSourcing && soldHoldPdpSourcingModal;
};

export const pdpSharedNotificationPdpSourcingModalConfig = {
    name: 'pdpSourcingModal',
    priority: PRIORITIES.PDP_SOURCING,
    rule: pdpSourcingRule,
    action: () => dispatch =>
        setTimeout(() => {
            dispatch({
                type: SHOW_PDP_SOURCING,
            });
        }, 5000),
};
